import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Pagination,
  Box,
} from '@mui/material';
import { sxStyle } from './styles';

const CustomMaterialTable = ({
  showOptions = true,
  showPagination,
  data: elements,
  onChangePage,
  title,
  columns,
  style,
  showRowStyle,
  detailPanel,
}) => {
  const { data, page, per_page, total } = elements;

  const handleChangePage = (_event, pag) => {
    onChangePage(pag);
  };

  const showPag = showPagination ?? showOptions;

  const rowStyle = showRowStyle ?? {
    overflowWrap: 'break-word',
    fontFamily: 'Open sans, sans-serif',
  };

  return (
    <div>
      <h2>{title}</h2>

      <TableContainer component={Paper} style={style}>
        <Table>
          <TableHead>
            <TableRow>
              {columns.map(col => (
                <TableCell key={col.field} align={col.align || 'left'}>
                  {col.title}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {data.map((row, rowIndex) => (
              <React.Fragment key={row.id || rowIndex}>
                <TableRow sx={rowStyle}>
                  {columns.map(col => (
                    <TableCell key={col.field} align={col.align || 'left'}>
                      {row[col.field]}
                    </TableCell>
                  ))}
                </TableRow>

                {/* detailPanel opcional */}
                {detailPanel &&
                  detailPanel.map(
                    (panel, idx) =>
                      panel.render(row) && (
                        <TableRow key={`detail-${idx}`}>
                          <TableCell colSpan={columns.length}>
                            {panel.render(row)}
                          </TableCell>
                        </TableRow>
                      )
                  )}
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {showPag && (
        <Box sx={sxStyle.pagination}>
          <Pagination
            count={Math.ceil(total / per_page)}
            page={page}
            onChange={handleChangePage}
            shape="rounded"
            size="small"
            color="primary"
            showFirstButton
            showLastButton
          />
        </Box>
      )}
    </div>
  );
};

export default CustomMaterialTable;
